import { useState } from 'react';
import { toast } from 'react-toastify';
import ExportService from './ExportService';


export const useManageExport = () => {
  const [loading, setLoading] = useState(false);

  const exportOrder = async (formData) => {
    setLoading(true);
    try {
      await ExportService.exportOrder(formData);
      return true
    } catch (error) {
      console.error('Export failed:', error);
      return error.message
    } finally {
      setLoading(false);
    }
  };

  const exportStockIn = async (formData) => {
    setLoading(true);
    try {
      await ExportService.exportStockIn(formData);
      return true
    } catch (error) {
      console.error('Export failed:', error);
      return error.message
    } finally {
      setLoading(false);
    }
  };

  const exportStockBalance = async (formData) => {
    setLoading(true);
    try {
      await ExportService.exportStockBalance(formData);
      return true;
    } catch (error) {
      console.error('Export failed:', error);
      return error.message;
    } finally {
      setLoading(false);
    }
  };

  // New function for exporting invoice
  const exportInvoice = async (invoiceId) => {
    setLoading(true);
    try {
      await ExportService.exportInvoice(9,2025);
      return true;
    } catch (error) {
      console.error('Invoice export failed:', error);
      return error.message;
    } finally {
      setLoading(false);
    }
  };

  const exportMonthlyReports = async (month, year) => {
    setLoading(true);
    try {
      await ExportService.exportMonthlyReports(month, year);
      return true;
    } catch (error) {
      console.error('Monthly reports export failed:', error);
      return error.message;
    } finally {
      setLoading(false);
    }
  };

  const exportMonthlyTaxInvoices = async (month, year) => {
    setLoading(true);
    try {
      const result = await ExportService.exportMonthlyTaxInvoices(month, year);
      if (result?.success) return true;
      if (result?.noData) return result.message || 'No tax invoices found for this month';
      return result?.error || 'Failed to export monthly tax invoices';
    } catch (error) {
      console.error('Monthly tax invoices export failed:', error);
      return error.message;
    } finally {
      setLoading(false);
    }
  };

  const getMissingDataCustomers = async (month, year) => {
    try {
      const data = await ExportService.getMissingDataCustomers(month, year);
      console.log(data)
      return data;
    } catch (error) {
      console.error('Failed to fetch missing data customers:', error);
      throw error;
    }
  };
  
  const exportAbb = async (companyOrderId) => {
    setLoading(true);
    try {
      await ExportService.exportAbb(companyOrderId);
      return true;
    } catch (error) {
      console.error('Invoice export failed:', error);
      return error.message;
    } finally {
      setLoading(false);
    }
  };

  const getCreditNoteEligibleOrders = async (month, year) => {
    try {
      const data = await ExportService.getCreditNoteEligibleOrders(month, year);
      return data;
    } catch (error) {
      console.error('Failed to fetch credit note eligible orders:', error);
      throw error;
    }
  };

  const assignCreditNoteDates = async (month, year, refundDates) => {
    setLoading(true);
    try {
      const result = await ExportService.assignCreditNoteDates(month, year, refundDates);
      if (result?.status === 'ok') return true;
      return result?.message || 'Failed to assign credit note dates';
    } catch (error) {
      console.error('Credit note assign failed:', error);
      return error?.response?.data?.message || error.message;
    } finally {
      setLoading(false);
    }
  };

  const exportMonthlyCreditNotes = async (month, year) => {
    setLoading(true);
    try {
      const result = await ExportService.exportMonthlyCreditNotes(month, year);
      if (result?.success) return true;
      if (result?.noData) return result.message || 'No credit notes found for this month';
      return result?.error || 'Failed to export credit notes';
    } catch (error) {
      console.error('Credit notes export failed:', error);
      return error.message;
    } finally {
      setLoading(false);
    }
  };

  const getWhtSummary = async (month, year) => {
    try {
      const data = await ExportService.getWhtSummary(month, year);
      return data;
    } catch (error) {
      console.error('Failed to fetch WHT summary:', error);
      throw error;
    }
  };

  return {
    loading,
    exportOrder,
    exportStockIn,
    exportStockBalance,
    exportInvoice,
    exportAbb,
    exportMonthlyReports,
    exportMonthlyTaxInvoices,
    getMissingDataCustomers,
    getCreditNoteEligibleOrders,
    assignCreditNoteDates,
    exportMonthlyCreditNotes,
    getWhtSummary,
  };
};
